import {
  SWITCH_ADMIN_MENU,
  SET_PROGRAMA_SELECTED,
  SET_USER
} from './ActionTypes';

export const switchAdminMenu = async (dispatch, menu) => {
  dispatch({ type: SWITCH_ADMIN_MENU, payload: menu });
};
export const selectPrograma = async (dispatch, programa) => {
  dispatch({ type: SET_PROGRAMA_SELECTED, payload: programa });
};
export const setUserLoged = async (dispatch, user) => {
  dispatch({
    type: SET_USER,
    payload: {
      email: user.email,
      avatar: user.photoURL,
      displayName: user.displayName
    }
  });
};
